// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.checkout {
  background-color: #fff;
}

.compartilhar {
  margin-top: -40px;
  margin-bottom: 60px;
  display: flex;
  color: #8b8b8b;
  flex-direction: row;
  text-align: start;
  height: 40px;
  border-radius: 5px;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  border: 2px solid rgba(216, 216, 216, 0.5);
}
.compartilhar .link-field {
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100%;
  padding-left: 5px;
}
.compartilhar .link-field span {
  align-self: center;
}
.compartilhar .button-link-field {
  height: 100%;
  width: 80px;
  display: flex;
  justify-content: center;
  align-content: center;
  background-color: #ededed;
  cursor: pointer;
  transition: 0.3s ease;
}
.compartilhar .button-link-field:hover {
  background-color: #e8e8e8;
}
.compartilhar .button-link-field span {
  align-self: center;
}

.panel {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.form-control {
  border: 1px solid #e2e2e2;
}

#form-checkout .has-error input {
  border-color: #e57373;
}
#form-checkout .has-error input:focus, #form-checkout .has-error input:hover {
  border: 1px solid #e57373;
}

.form-control.error {
  border: 1px solid #e57373;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
/*  alterações novas  */
.panel-body-altera {
  text-align: right;
}

.panel-body-altera .btn-confirmar {
  margin-bottom: 5px;
}

.panel-body-altera .cartoes-cadastrados {
  padding-bottom: 80px;
  padding-top: 10px;
}

.panel-body-altera .cartoes-cadastrados .cartao {
  padding: 10px;
  border: 2px solid #00caff;
  border-radius: 5px;
  background-color: #fff;
  text-align: left;
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: hsl(0, 0%, 30%);
  font-size: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.5s ease-out;
  position: relative;
}
.panel-body-altera .cartoes-cadastrados .cartao.card-red {
  border: 2px solid #e57373;
}
.panel-body-altera .cartoes-cadastrados .cartao .error-action-card {
  color: #e57373;
  position: absolute;
  bottom: -10px;
  left: 10px;
}

.panel-body-altera .cartoes-cadastrados .cartao.disabled {
  background-color: #fcfcfc;
  border: 2px solid rgba(216, 216, 216, 0.5);
  color: #8b8b8b;
  transition: background-color 0.5s ease, border-color 0.5s ease;
}

.panel-body-altera .cartoes-cadastrados .cartao.disabled:hover {
  background-color: #fff;
  border-color: rgb(216, 216, 216);
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao {
  background-color: #fcfcfc;
  border: 2px solid rgba(216, 216, 216, 0.5);
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: bolder;
  padding-left: 30px;
  transition: background-color 0.5s ease, border-color 0.5s ease;
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao:hover {
  background-color: #fff;
  border-color: rgb(216, 216, 216);
}

.panel-body-altera .cartoes-cadastrados .cartao.novo-cartao span > span {
  font-size: 19px;
  line-height: 1;
}

.panel-body-altera .cartoes-cadastrados .cartao .bandeira-cartao {
  margin: 0;
  display: inline-block;
  vertical-align: middle;
  height: 26px;
  width: 66px;
}

.panel-body-altera .cartoes-cadastrados .cartao .editar-cartao-button {
  width: 7px;
  height: 19px;
  display: inline-block;
  background-image: url(/assets/icones/menu-edit.svg);
  background-repeat: no-repeat;
  padding: 10px;
  background-position: center;
}

.panel-body-altera .cartoes-cadastrados .cartao .final-pan strong,
.cartoes-cadastrados .cartao .validade-cartao strong {
  font-family: pague-la, "Open Sans", sans-serif;
  font-size: 15px;
}

.remover-dom {
  visibility: hidden;
  opacity: 0;
  display: none;
}

.flex {
  display: flex;
}

.space-between {
  justify-content: space-between;
  align-items: center;
}

h5 {
  color: #4d4d4d;
  font-size: 14px;
  line-height: inherit;
}

.info-venda .venda:last-child {
  margin-bottom: 20px;
}

.venda .valores {
  margin-bottom: 5px;
}

.venda .data-entrada {
  font-size: 12px;
  text-align: right;
  position: relative;
}

.venda .data-entrada .texto-data {
  position: absolute;
  left: 0px;
  color: #999999;
}

.venda .data-entrada .valor-data {
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: bolder;
  font-size: 13px;
}

.venda .valor-entrada {
  display: block;
  font-family: pague-la, "Open Sans", sans-serif;
  font-weight: bolder;
  font-size: 13px;
  text-align: right;
}

/* #cartoes-cadastrados, #form-checkout {
    transition: opacity 0.5s ease;
} */
@media (min-width: 768px) {
  .checkout .cls-content .cls-content-lg {
    width: 700px;
  }
}
.menu-remove {
  background-color: #FFF;
  width: 100px;
  height: 35px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 7px;
  text-align: center;
  border-radius: 0.25rem;
  position: relative;
  top: 12px;
  left: -78px;
  z-index: 10;
}

.menu-remove:hover {
  background-color: #EFEFEF;
}

@media (min-width: 768px) {
  .checkout .cls-content .cls-content-lg {
    width: 700px;
  }
}
.checkout.cls-container {
  background-color: #FFFFFF;
}

.checkout .cls-content {
  padding-top: 5vh;
}

.checkout .rodape {
  margin-top: 30px;
}

.checkout .rodape p {
  margin-right: auto;
  margin-left: auto;
}

.checkout .panel-content {
  display: flex;
}

.checkout p,
.checkout h4,
.checkout h5 {
  display: table;
}

.mb-clean {
  margin-bottom: 0;
}

.checkout .panel-body1 {
  width: 35%;
  background-color: #fff;
  padding: 20px 40px 25px;
  border-bottom-left-radius: 10px;
}

.checkout .panel-body1 .total {
  font-size: 18px;
  font-family: "Pague.la", "Open Sans", sans-serif;
}

.checkout .panel-body1 p {
  color: #999999;
  margin-bottom: 8px;
}

.checkout .panel-body1 h4 {
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 25px;
  font-weight: 900;
  margin-top: 0;
}

.checkout .texto-destaque {
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 900;
  margin-top: 0;
}

.checkout .texto-destaque-normal {
  color: #4379ff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 400;
  margin-top: 0;
}

.checkout .panel-body1 h5 {
  margin-top: 15px;
}

.checkout .panel-body2 {
  width: 65%;
  background-color: #fcfcfc;
  padding: 20px 40px 35px;
}

.checkout .panel .desc-parcelas {
  text-align: right;
}

.checkout .panel .desc-parcelas p {
  color: #999999;
  display: inline-block;
}

@media (min-width: 768px) {
  .checkout .cartao-credito {
    width: 100%;
  }
  #resultado-reprovado .link-back {
    position: absolute;
    bottom: 40px;
    left: none;
  }
}
.checkout .form-control {
  font-size: 15px;
  font-weight: bolder;
}

input:-moz-placeholder,
input::-webkit-input-placeholder,
input:-ms-input-placeholder {
  color: red;
}

.checkout .panel {
  border-radius: 10px;
}

.checkout .panel-heading {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 80px;
  border-bottom: none;
}

.panel-title a {
  color: inherit;
  cursor: pointer;
}

.pagamento-seguro {
  text-align: right;
  position: absolute;
  right: 40px;
  top: 20px;
  color: #ffffff;
}

.pagamento-seguro p {
  display: inline-block;
}

.pagamento-seguro p strong {
  display: block;
}

.checkout .panel-heading:after {
  border-bottom: none;
}

.checkout .logo-paguela-cinza {
  margin-bottom: 30px;
}

.checkout .logo-paguela-cinza svg {
  height: 30px;
}

.checkout .panel-heading h3 {
  color: #fff;
  letter-spacing: 1px;
  text-align: left;
  font-size: 25px;
  padding-top: 15px;
  padding-left: 40px;
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-weight: 100;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: default;
}

z .checkout label,
.registro .pad-all {
  color: #999999;
}

.checkout input,
.registro select {
  border-radius: 4px;
  border-color: #d9d9d9;
}

.checkout input:focus {
  border-color: #00CAFF;
}

.checkout .panel-heading {
  background: rgb(0, 204, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 204, 255)), color-stop(70%, rgb(161, 80, 253)), color-stop(100%, rgb(177, 54, 253)));
  background: linear-gradient(15deg, rgb(0, 204, 255) 0%, rgb(161, 80, 253) 70%, rgb(177, 54, 253) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00ccff", endColorstr="#b136fd", GradientType=1);
}

.mt-20 {
  margin-top: 20px;
}

.btn-registrar,
.btn-primary {
  position: absolute;
  bottom: 40px;
  right: 40px;
  font-family: "Pague.la", "Open Sans", sans-serif;
  color: #fff;
  font-size: 1.8rem;
  padding: 7.5px 27px;
  border-radius: 5px;
  letter-spacing: 0.8px;
  background: #22b5ff;
  background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));
  background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#22b5ff", endColorstr="#a42cff", GradientType=1);
  border: none;
  float: right;
}
@media screen and (max-width: 769px) {
  .btn-registrar,
  .btn-primary {
    bottom: 10px;
    right: 20px;
  }
}

.btn-registrar:active,
.btn-primary:active,
.btn-registrar:hover,
.btn-primary:hover,
.btn-registrar:focus .btn-primary:focus {
  color: #fff;
  background: #22b5ff;
  background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));
  background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#22b5ff", endColorstr="#a42cff", GradientType=1);
}

#reinicia-venda {
  float: none;
}

.cadeado {
  max-width: 35px;
  display: inline-block;
  position: relative;
  top: 2px;
}

.cadeado svg {
  height: 30px;
}

#cartao-error {
  margin-bottom: 0 !important;
}

.checkout .form-group {
  margin-bottom: 15px;
}

.checkout .form-group .control-label {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

img.logo-cliente {
  max-width: 165px;
  max-height: 117px;
  margin: 10px auto;
}

.bandeira-cartao {
  width: 50px;
  height: 27px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin: 7px 0 0 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  right: 8px;
  top: 3px;
}

.checkout .has-feedback label ~ .form-control-feedback {
  top: 27px;
  right: 10px;
}

.default {
  opacity: 0;
}

.master,
.visa,
.elo,
.diners,
.aura,
.jcb,
.hipercard,
.amex {
  opacity: 1;
}

.master {
  background-image: url("/assets/icones/mastercard.svg");
}

.hipercard {
  background-image: url("/assets/icones/hipercard.png");
}

.visa {
  background-image: url("/assets/icones/visa.svg");
}

.amex {
  background-image: url("/assets/icones/american-express.svg");
}

.diners {
  background-image: url("/assets/icones/diners.svg");
}

.discover {
  background-image: url("/assets/icones/discover.svg");
}

.elo {
  background-image: url("/assets/icones/elo.svg");
}

.jcb {
  background-image: url("/assets/icones/jbc.png");
}

@media only screen and (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
  .jcb {
    background-image: url("/assets/icones/jbc@2x.png");
  }
}
.aura {
  background-image: url("/assets/icones/aura.png");
}

@media only screen and (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
  .aura {
    background-image: url("/assets/icones/aura@2x.png");
  }
}
.btn.loading {
  color: transparent;
  height: 35px;
  width: 35px;
  padding: 0;
  border-radius: 50%;
  animation: loadBotao 0.25s ease, spin 0.75s linear infinite 0.25s;
}

.btn.loading:before {
  content: "";
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background-color: #fcfcfc;
  position: relative;
  display: block;
  margin: 1px;
}

@keyframes loadBotao {
  from {
    height: initial;
    width: initial;
  }
  to {
    height: 35px;
    width: 35px;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#nometitular-error {
  margin-bottom: 40px;
}

#nometitular-error,
#cartao-error {
  color: #eb2521;
}

@media (max-width: 767px) {
  .checkout .panel-heading h3 {
    padding-left: 20px;
  }
  .checkout .cls-content {
    padding: 0;
  }
  .checkout .cls-content .cls-content-lg {
    width: 100%;
    box-shadow: none;
  }
  .checkout .panel-content {
    display: block;
  }
  .logo-cliente {
    display: block !important;
  }
  .info-loja * {
    display: block !important;
  }
  .panel-body2,
  .panel-body1 {
    width: 100% !important;
    text-align: center;
    padding: 20px !important;
  }
  .pagamento-seguro {
    right: 20px;
  }
  .info-pagamento {
    display: flex;
    justify-content: space-between;
  }
  #nometitular {
    margin-bottom: 100px;
  }
  .checkout .panel-heading {
    border-radius: 0;
  }
  /* .checkout .panel-heading h3 {
    position: relative;
    text-align: center;
    padding: 15px 0 0;
  }
  .pagamento-seguro {
    position: relative;
    text-align: center;
    top: 0;
    right: 0;
  }
  .pagamento-seguro p {
    text-align: right;
  } */
  .checkout .panel-body1 p.totais {
    position: absolute;
    float: left;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
#resultado-sucesso h3 {
  display: block;
  color: #00caff;
  font-family: "Pague.la", "Open Sans", sans-serif;
  margin-top: 8px;
}

#resultado-reprovado h3 {
  display: block;
  color: #e95753;
  margin-top: 8px;
  font-family: "Pague.la", "Open Sans", sans-serif;
}

/*altura SVGS de validação*/
#resultado-sucesso svg,
#resultado-reprovado svg {
  height: 75px;
}

/*animação círculos svgs*/
#resultado-sucesso svg circle,
#resultado-reprovado svg circle {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2.5s ease forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
/* animação somente de sucesso */
#resultado-sucesso svg polyline {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 3.5s ease forwards;
  animation-delay: 0.25s;
}

#resultado-reprovado svg .linha-1 {
  transform: translate(20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.3s;
}

#resultado-reprovado svg .linha-2 {
  transform: translate(-20px, -20px);
  opacity: 0;
  animation: entrando 0.25s ease-in forwards;
  animation-delay: 0.4s;
}

@keyframes entrando {
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
/* animação reprovado */
#resultado-reprovado svg {
  animation: shake-reprovado 0.35s ease forwards;
  animation-delay: 0.6s;
}

@keyframes shake-reprovado {
  10%, 90% {
    transform: translate3d(0, -1px, 0);
  }
  20%, 80% {
    transform: translate3d(0, 2px, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(0, -4px, 0);
  }
  40%, 60% {
    transform: translate3d(0, 4px, 0);
  }
}
#resultado-sucesso .bandeira-cartao {
  position: absolute;
  top: -5px;
  right: 0px;
}

#resultado-sucesso .info-cartao {
  position: relative;
  padding-right: 75px;
}

#resultado-sucesso .fechar {
  margin-top: 40px;
}

#resultado-sucesso .info-transacao-aprovada {
  margin-top: 20px;
}

#resultado-sucesso .info-transacao-aprovada hr {
  margin: 10px 0 !important;
}

#resultado-sucesso .dados-aprovados {
  display: flex;
  justify-content: space-between;
}

.margin-auto {
  margin: 0 auto;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

/* página 404 */
.pagina-404 #container {
  background: rgb(0, 247, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 247, 255)), color-stop(75%, rgb(170, 0, 255)), color-stop(100%, rgb(170, 0, 255)));
  background: linear-gradient(45deg, rgb(0, 247, 255) 0%, rgb(170, 0, 255) 75%, rgb(170, 0, 255) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00f7ff", endColorstr="#aa00ff", GradientType=1);
}

.pagina-404 .btn-confirmar {
  position: initial;
}

.pagina-404 .text-main {
  font-family: pague-la, "open sans", sans-serif;
  font-size: 2rem;
}

h1.error-code {
  font-family: pague-la, "open sans", sans-serif;
  color: #fff;
}

.checkout-table {
  width: 100%;
  margin: 20px 0;
}
.checkout-table tbody tr td {
  color: #777777;
  border-bottom: 1px solid #cccccc;
  padding: 10px 0 5px;
}

.scheduled-transations {
  margin-top: 40px;
}

.show-table {
  overflow: hidden;
  max-height: 300px;
  transition: max-height 1s ease;
}

.hide-table {
  overflow: hidden;
  max-height: 0px;
  transition: max-height 1s ease;
}

.modal-checkout {
  z-index: 10;
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  background-color: rgba(18, 0, 64, 0.85);
  font-family: "Pague.la", "Open Sans", sans-serif;
}
.modal-checkout.modal-checkout-show {
  display: block;
  animation-name: fade;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show .icon {
  animation-name: fade;
  animation-delay: 0.2s;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show span:first-child {
  animation-name: fade;
  animation-delay: 0.4s;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show span:last-child {
  animation-name: fade;
  animation-delay: 0.6s;
  animation-duration: 0.8s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout.modal-checkout-show button {
  animation-name: fade;
  animation-delay: 0.8s;
  animation-duration: 1.1s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}
.modal-checkout div:first-child {
  position: relative;
  top: 30%;
}
.modal-checkout span {
  opacity: 1;
  width: 100%;
  display: inline-block;
}
.modal-checkout .icon {
  opacity: 1;
  width: 60px;
  margin: 0 auto;
}
.modal-checkout .icon img {
  width: 100%;
  margin: 20px 0;
}
.modal-checkout .text {
  color: #fff;
  font-size: 36px;
}
.modal-checkout .button {
  top: 120px;
  left: 40px;
  right: 0;
  width: 200px;
  margin: 0 auto;
  transition: 0.5s;
  position: relative;
}
.modal-checkout .button button {
  opacity: 0;
  width: 200px;
}

.erro-reprovacao {
  margin-bottom: 80px;
}

.link-back {
  margin-top: 50px;
}
.link-back a {
  transition: 0s;
}
.link-back a h4 {
  display: block;
  font-size: 18px;
  font-weight: 500;
  color: #00caff;
  font-family: "Pague.la", "Open Sans", sans-serif;
}
.link-back a:hover {
  text-decoration: underline;
}

#resultado-reprovado .link-back, #cartoes-cadastrados .link-back, #form-checkout .link-back {
  position: absolute;
  bottom: 40px;
  left: 40px;
}

@media (min-width: 768px) {
  #resultado-reprovado .link-back, #cartoes-cadastrados .link-back, #form-checkout .link-back {
    bottom: 40px;
    left: inherit;
    position: absolute;
  }
}
.valication-result-error {
  text-align: center;
  color: #e57373;
}

a {
  cursor: pointer;
}

.qtd-vezes {
  font-size: 10px;
  color: #4379ff;
}

.button-not-allowed {
  top: 120px;
  left: 40px;
  right: 0;
  width: 200px;
  margin: 0 auto;
  transition: 0.5s;
  position: relative;
}
.button-not-allowed button {
  opacity: 1;
  width: 200px;
}

.iframe-cybersource {
  border: 0;
  width: 100%;
  height: 100%;
  top: -5000px;
  position: absolute;
}

.mb-70 {
  margin-bottom: 70px;
}

.modal-header {
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  padding: 15px;
  position: absolute;
}
.modal-header:after {
  content: normal;
}
.modal-header h2 {
  font-weight: 100;
  text-align: center;
}
.modal-header.header-removido {
  background-color: rgba(34, 183, 255, 0.25);
}
.modal-header.header-removido h2 {
  color: #22b7ff;
}
.modal-header.header-remover {
  background-color: rgba(229, 115, 115, 0.25);
}
.modal-header.header-remover h2 {
  color: #e57373;
}

.modal-body {
  margin-top: 90px;
}
.modal-body .text-center {
  text-align: center;
}
.modal-body p {
  font-size: 14px;
  font-weight: 600;
}
.modal-body p.info-cartao {
  margin: 5px 0 0 -4px;
}
.modal-body p .bandeira-cartao {
  margin-top: -4px;
  margin-right: 5px;
}
.modal-body p small {
  margin-left: 5px;
  color: #999999;
  font-weight: 200;
}
.modal-body h3 {
  margin-bottom: 30px;
  margin-top: 0px;
  font-size: 18px;
}
.modal-body .empty {
  color: #999999;
  font-weight: 300;
  font-size: 16px;
}
.modal-body .color-red {
  color: #e57373;
}
.modal-body .btn-action {
  float: left;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.modal-body .btn {
  margin-top: 20px;
}
.modal-body .btn:first-child {
  margin-right: 2px;
}
.modal-body .btn:last-child {
  margin-left: 2px;
}
.modal-body .btn.loading {
  margin-right: 30px;
}
.modal-body .btn.loading::before {
  background-color: #fff;
}
.modal-body .btn-remover {
  float: right;
  color: #fff;
  line-height: 23px;
  background-color: #e57373;
}
.modal-body .btn-default {
  font-size: 16px;
  padding: 5.5px 16px;
  border: none;
  background-color: rgba(204, 204, 204, 0.25);
}
.modal-body .btn-default:hover {
  background-color: rgba(204, 204, 204, 0.5);
}
.modal-body .btn-excluido {
  left: 50%;
  position: relative;
  transform: translateX(-50%);
}
.modal-body .textarea {
  border: 0px;
  outline: none;
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 0px 12px;
}
.modal-body .textarea.color-red {
  box-shadow: 0px 0px 12px -2px #e57373;
}
.modal-body svg {
  left: 50%;
  width: 90px;
  height: 90px;
  position: relative;
  margin-bottom: 50px;
  transform: translateX(-50%);
}

.cartao-invalido, .bandeira-invalida {
  color: #e57373;
  display: block;
}

.bandeiras {
  margin-bottom: 10px;
}
.bandeiras label {
  display: block;
  font-size: 12px;
  color: #999999;
}
.bandeiras figure {
  padding: 2px;
  transition: 0.6s;
  border-radius: 3px;
  margin: 0 4px 15px 0;
  background-size: 40px auto;
  border: solid 1px #e6e6e6;
}
.bandeiras figure:hover {
  transition: 0.6s;
  cursor: pointer;
  border-color: #00caff;
  background-color: rgba(236, 236, 236, 0.4);
}
.bandeiras figure.bandeira-selecionada {
  border-color: #00caff;
}

.footer-credito-parcelado {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}

.checkout-bloqueado {
  animation: blur-bloqueio 1s ease-in-out forwards;
}

@keyframes blur-bloqueio {
  0% {
    filter: blur(0);
  }
  100% {
    filter: blur(20px);
  }
}
.panel-body1 {
  display: flex;
  flex-direction: column;
}

.body-qrcode {
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.body-qrcode .button-expand {
  width: 50px;
  height: 50px;
}

.align-center {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo__pix {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
}
.logo__pix svg {
  width: 170px;
}

.compartilhar {
  margin-top: 30px;
  margin-bottom: unset;
  display: flex;
  color: #8b8b8b;
  flex-direction: row;
  text-align: start;
  height: 40px;
  border-radius: 5px;
  justify-content: space-between;
  align-content: center;
  width: 428px;
  border: 2px solid rgba(216, 216, 216, 0.5);
}

.link-field {
  width: 100%;
  border: none;
}
.link-field:focus {
  outline: none;
}

.copiar-pix {
  width: 120px !important;
}

.short-link {
  margin-top: 10px;
}

.qrcode__desktop {
  display: block;
}

.qrcode__mobile {
  display: none;
}

@media only screen and (max-width: 450px) {
  .qrcode__desktop {
    display: none !important;
  }
  .qrcode__mobile {
    display: block !important;
  }
  .compartilhar {
    margin-left: 10px;
    margin-right: 10px;
  }
  .panel-body1 {
    width: 100%;
  }
  .pix__copiar {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
@supports (animation: grow 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards) {
  .tick {
    stroke-opacity: 0;
    stroke-dasharray: 29px;
    stroke-dashoffset: 29px;
    animation: draw 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards;
    animation-delay: 0.6s;
  }
  .circle {
    fill-opacity: 0;
    stroke: #2cd355;
    stroke-width: 16px;
    transform-origin: center;
    transform: scale(0);
    animation: grow 1s cubic-bezier(0.25, 0.25, 0.25, 1.25) forwards;
  }
}
@keyframes grow {
  60% {
    transform: scale(0.8);
    stroke-width: 4px;
    fill-opacity: 0;
  }
  100% {
    transform: scale(0.9);
    stroke-width: 8px;
    fill-opacity: 1;
    fill: #2cd355;
  }
}
@keyframes draw {
  0%, 100% {
    stroke-opacity: 1;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
body {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cobranca__processada {
  width: 420px;
  height: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 20px;
  color: #2cd355;
}

.loading {
  width: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading svg {
  stroke: #548bfe;
  width: 100px;
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/checkout/components/pix/pix.component.scss","webpack://./src/app/modules/checkout/components/checkout/checkout.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;EACE,sBCsBM;AFtBR;;ACEA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,0CAAA;ADCF;ACCE;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;ADCJ;ACAI;EACE,kBAAA;ADEN;ACEE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ADAJ;ACEI;EACE,yBAAA;ADAN;ACEI;EACE,kBAAA;ADAN;;ACMA;EACE,sBC1BM;ED2BN,wCAAA;ADHF;;ACMA;EACE,yBAAA;ADHF;;ACMA;EACE,qBC1BO;AFuBT;ACIE;EACE,yBAAA;ADFJ;;ACMA;EACI,yBAAA;EACA,gEAAA;EACA,+BAAA;EACA,2BAAA;EACA,mBAAA;ADHJ;;ACME;EACE;IAEE,kCAAA;EDJJ;ECME;IAEE,iCAAA;EDLJ;ECOE;IAGE,kCAAA;EDPJ;ECSE;IAEE,iCAAA;EDRJ;AACF;ACWE,uBAAA;AAEA;EACE,iBAAA;ADVJ;;ACaE;EACE,kBAAA;ADVJ;;ACaE;EACI,oBAAA;EACA,iBAAA;ADVN;;ACaE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,kBAAA;ADVJ;ACWI;EACE,yBAAA;ADTN;ACWI;EACE,cChGG;EDiGH,kBAAA;EACA,aAAA;EACA,UAAA;ADTN;;ACaE;EACE,yBAAA;EACA,0CAAA;EACA,cAAA;EACA,8DAAA;ADVJ;;ACaE;EACE,sBAAA;EACA,gCAAA;ADVJ;;ACaE;EACE,yBAAA;EACA,0CAAA;EAEA,cAAA;EACA,gDClHa;EDmHb,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,8DAAA;ADXJ;;ACcE;EACE,sBAAA;EACA,gCAAA;ADXJ;;ACcE;EACE,eAAA;EACA,cAAA;ADXJ;;ACcE;EACE,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;ADXJ;;ACcE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,mDAAA;EACA,4BAAA;EACA,aAAA;EACA,2BAAA;ADXJ;;ACcE;;EAEE,8CAAA;EACA,eAAA;ADXJ;;ACcE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;ADXJ;;ACcE;EACE,aAAA;ADXJ;;ACcE;EACE,8BAAA;EACA,mBAAA;ADXJ;;ACcE;EACE,cAAA;EACA,eAAA;EACA,oBAAA;ADXJ;;ACcE;EACI,mBAAA;ADXN;;ACcE;EACI,kBAAA;ADXN;;ACcE;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;ADXN;;ACcE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;ADXJ;;ACcE;EACI,8CAAA;EACA,mBAAA;EACA,eAAA;ADXN;;ACcE;EACE,cAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ADXJ;;ACcE;;GAAA;AAIA;EACE;IACE,YAAA;EDZJ;AACF;ACeE;EACE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ADbJ;;ACgBE;EACE,yBAAA;ADbJ;;ACgBE;EACE;IACE,YAAA;EDbJ;AACF;ACwBE;EACE,yBAAA;ADtBJ;;ACyBE;EACE,gBAAA;ADtBJ;;ACyBE;EACE,gBAAA;ADtBJ;;ACyBE;EACE,kBAAA;EACA,iBAAA;ADtBJ;;ACyBE;EACE,aAAA;ADtBJ;;ACyBE;;;EAGE,cAAA;ADtBJ;;ACyBE;EACE,gBAAA;ADtBJ;;ACyBE;EACE,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;ADtBJ;;ACyBE;EACE,eAAA;EACA,gDCpSa;AF8QjB;;ACyBE;EACE,cAAA;EACA,kBAAA;ADtBJ;;ACyBE;EACE,cAAA;EACA,gDC9Sa;ED+Sb,eAAA;EACA,gBAAA;EACA,aAAA;ADtBJ;;ACyBE;EACE,cAAA;EACA,gDCtTa;EDuTb,eAAA;EACA,gBAAA;EACA,aAAA;ADtBJ;;ACyBA;EACE,cAAA;EACA,gDC9Te;ED+Tf,eAAA;EACA,gBAAA;EACA,aAAA;ADtBF;;ACyBE;EACE,gBAAA;ADtBJ;;ACyBE;EACE,UAAA;EACA,yBAAA;EACA,uBAAA;ADtBJ;;ACyBE;EACE,iBAAA;ADtBJ;;ACyBA;EACI,cAAA;EACA,qBAAA;ADtBJ;;ACyBE;EACE;IACE,WAAA;EDtBJ;EC0BI;IACE,kBAAA;IACA,YAAA;IACA,UAAA;EDxBN;AACF;AC4BE;EACE,eAAA;EACA,mBAAA;AD1BJ;;AC6BE;;;EAGE,UAAA;AD1BJ;;AC6BE;EACE,mBAAA;AD1BJ;;AC6BE;EACE,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AD1BJ;;AC6BE;EACE,cAAA;EACA,eAAA;AD1BJ;;AC6BE;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;AD1BJ;;AC6BE;EACE,qBAAA;AD1BJ;;AC6BE;EACE,cAAA;AD1BJ;;AC6BE;EACE,mBAAA;AD1BJ;;AC6BE;EACE,mBAAA;AD1BJ;;AC6BE;EACE,YAAA;AD1BJ;;AC6BE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gDCnaa;EDoab,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AD1BJ;;AC6BE;;EAEE,cAAA;AD1BJ;;AC6BE;;EAEE,kBAAA;EACA,qBAAA;AD1BJ;;AC6BE;EACE,qBAAA;AD1BJ;;AC6BE;EACE,4BAAA;EAEA,+JAAA;EAIA,sGAAA;EACA,mHAAA;AD1BJ;;AC6BE;EACE,gBAAA;AD1BJ;;AC6BE;;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gDC/cW;EDgdX,WC/dE;EDgeF,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,sLAAA;EAIA,mGAAA;EACA,mHAAA;EACA,YAAA;EACA,YAAA;AD1BN;AC4BI;EAtBF;;IAuBI,YAAA;IACA,WAAA;EDxBJ;AACF;;AC2BE;;;;;EAKI,WAAA;EACA,mBAAA;EAEA,sLAAA;EAIA,mGAAA;EACA,mHAAA;ADxBN;;AC2BE;EACE,WAAA;ADxBJ;;AC2BE;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;ADxBJ;;AC2BE;EACE,YAAA;ADxBJ;;AC2BE;EACE,2BAAA;ADxBJ;;AC2BE;EACE,mBAAA;ADxBJ;;AC2BE;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ADxBJ;;AC2BE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;ADxBJ;;AC2BE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,iBAAA;EACA,UAAA;EAEA,6BAAA;EACA,UAAA;EACA,QAAA;ADxBJ;;AC2BE;EACE,SAAA;EACA,WAAA;ADxBJ;;AC2BE;EACE,UAAA;ADxBJ;;AC2BE;;;;;;;;EAQE,UAAA;ADxBJ;;AC2BE;EACE,sDAAA;ADxBJ;;AC2BE;EACE,qDAAA;ADxBJ;;AC2BE;EACE,gDAAA;ADxBJ;;AC2BE;EACE,4DAAA;ADxBJ;;AC2BE;EACE,kDAAA;ADxBJ;;AC2BE;EACE,oDAAA;ADxBJ;;AC2BE;EACE,+CAAA;ADxBJ;;AC2BE;EACE,+CAAA;ADxBJ;;AC2BE;EAIE;IACE,kDAAA;ED3BJ;AACF;AC8BE;EACE,gDAAA;AD5BJ;;AC+BE;EAIE;IACE,mDAAA;ED/BJ;AACF;ACkCE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iEAAA;ADhCJ;;ACmCE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ADhCJ;;ACmCE;EACE;IACE,eAAA;IACA,cAAA;EDhCJ;ECkCE;IACE,YAAA;IACA,WAAA;EDhCJ;AACF;ACmCE;EACE;IACE,uBAAA;EDjCJ;ECmCE;IACE,yBAAA;EDjCJ;AACF;ACoCE;EACE,mBAAA;ADlCJ;;ACqCE;;EAEE,cAAA;ADlCJ;;ACqCE;EACE;IACE,kBAAA;EDlCJ;ECqCE;IACE,UAAA;EDnCJ;ECsCE;IACE,WAAA;IACA,gBAAA;EDpCJ;ECuCE;IACE,cAAA;EDrCJ;ECuCE;IACE,yBAAA;EDrCJ;ECuCE;IACE,yBAAA;EDrCJ;ECuCE;;IAEE,sBAAA;IACA,kBAAA;IACA,wBAAA;EDrCJ;ECuCE;IACE,WAAA;EDrCJ;ECuCE;IACE,aAAA;IACA,8BAAA;EDrCJ;ECuCE;IACE,oBAAA;EDrCJ;ECuCE;IACE,gBAAA;EDrCJ;ECuCE;;;;;;;;;;;;;KAAA;EAcA;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,6BAAA;EDrCJ;AACF;ACwCE;EACE,cAAA;EACA,cAAA;EACA,gDCruBa;EDsuBb,eAAA;ADtCJ;;ACyCE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gDC7uBa;AFusBjB;;ACyCE,2BAAA;AAEA;;EAEE,YAAA;ADvCJ;;AC0CE,yBAAA;AAEA;;EAEE,sBAAA;EACA,uBAAA;EACA,kCAAA;ADxCJ;;AC2CE;EACE;IACE,oBAAA;EDxCJ;AACF;AC2CE,gCAAA;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;AD1CJ;;AC6CE;EACE,iCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AD1CJ;;AC6CE;EACE,kCAAA;EACA,UAAA;EACA,0CAAA;EACA,qBAAA;AD1CJ;;AC6CE;EACE;IACE,8BAAA;IACA,UAAA;ED1CJ;AACF;AC6CE,uBAAA;AAEA;EACE,8CAAA;EACA,qBAAA;AD5CJ;;AC+CE;EACE;IAEE,kCAAA;ED7CJ;EC+CE;IAEE,iCAAA;ED9CJ;ECgDE;IAGE,kCAAA;EDhDJ;ECkDE;IAEE,iCAAA;EDjDJ;AACF;ACoDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADlDJ;;ACqDE;EACE,kBAAA;EACA,mBAAA;ADlDJ;;ACqDE;EACE,gBAAA;ADlDJ;;ACqDE;EACE,gBAAA;ADlDJ;;ACqDE;EACE,yBAAA;ADlDJ;;ACqDE;EACE,aAAA;EACA,8BAAA;ADlDJ;;ACqDE;EACE,cAAA;ADlDJ;;ACqDE;EACE,8BAAA;ADlDJ;;ACqDE;EACE,2BAAA;ADlDJ;;ACqDE,eAAA;AAEA;EACE,4BAAA;EAEA,6JAAA;EAIA,oGAAA;EACA,mHAAA;ADnDJ;;ACsDE;EACE,iBAAA;ADnDJ;;ACsDE;EACE,8CAAA;EACA,eAAA;ADnDJ;;ACsDE;EACE,8CAAA;EACA,WAAA;ADnDJ;;ACsDE;EACE,WAAA;EACA,cAAA;ADnDJ;ACsDQ;EACE,cC/5BE;EDg6BF,gCAAA;EACA,mBAAA;ADpDV;;AC0DE;EACE,gBAAA;ADvDJ;;AC0DE;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;ADvDJ;;AC0DE;EACE,gBAAA;EACA,eAAA;EACA,8BAAA;ADvDJ;;AC0DE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,gDCz6Ba;AFk3BjB;ACwDI;EACE,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;ADtDN;ACuDM;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;ADrDR;ACuDM;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;ADrDR;ACuDM;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;ADrDR;ACuDM;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;ADrDR;ACyDI;EACE,kBAAA;EACA,QAAA;ADvDN;AC0DI;EACE,UAAA;EACA,WAAA;EACA,qBAAA;ADxDN;AC2DI;EACE,UAAA;EACA,WAAA;EACA,cAAA;ADzDN;AC2DM;EACE,WAAA;EACA,cAAA;ADzDR;AC6DI;EACE,WCp/BE;EDq/BF,eAAA;AD3DN;AC8DI;EACE,UAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AD5DN;AC8DM;EACE,UAAA;EACA,YAAA;AD5DR;;ACiEE;EACE,mBAAA;AD9DJ;;ACiEE;EACE,gBAAA;AD9DJ;AC+DI;EACE,cAAA;AD7DN;AC8DM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gDCtgCS;AF08BjB;AC8DM;EACE,0BAAA;AD5DR;;ACkEI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AD/DN;;ACmEE;EAEI;IACE,YAAA;IACA,aAAA;IACA,kBAAA;EDjEN;AACF;ACqEE;EACE,kBAAA;EACA,cCxiCK;AFq+BT;;ACsEE;EACE,eAAA;ADnEJ;;ACuEE;EACE,eAAA;EACA,cAAA;ADpEJ;;ACuEE;EACE,UAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ADpEJ;ACsEI;EACE,UAAA;EACA,YAAA;ADpEN;;ACwEE;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;ADrEJ;;ACwEE;EACE,mBAAA;ADrEJ;;ACwEE;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ADrEJ;ACsEI;EACI,eAAA;ADpER;ACsEI;EACI,gBAAA;EACA,kBAAA;ADpER;ACsEI;EACI,0CAAA;ADpER;ACqEQ;EACI,cC3nCD;AFwjCX;ACsEI;EACI,2CAAA;ADpER;ACqEQ;EACE,cCvmCD;AFoiCT;;ACwEE;EACE,gBAAA;ADrEJ;ACuEI;EACE,kBAAA;ADrEN;ACwEI;EACE,eAAA;EACA,gBAAA;ADtEN;ACwEM;EACE,oBAAA;ADtER;ACyEM;EACE,gBAAA;EACA,iBAAA;ADvER;AC0EM;EACE,gBAAA;EACA,cClpCI;EDmpCJ,gBAAA;ADxER;AC4EI;EACE,mBAAA;EACA,eAAA;EACA,eAAA;AD1EN;AC6EI;EACE,cC9pCM;ED+pCN,gBAAA;EACA,eAAA;AD3EN;AC8EI;EACE,cCppCG;AFwkCT;AC+EI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AD7EN;ACgFI;EACE,gBAAA;AD9EN;ACgFM;EACE,iBAAA;AD9ER;ACiFM;EACE,gBAAA;AD/ER;ACkFM;EACE,kBAAA;ADhFR;ACkFQ;EACE,sBAAA;ADhFV;ACqFI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;ADnFN;ACsFI;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,2CAAA;ADpFN;ACsFM;EACE,0CAAA;ADpFR;ACwFI;EACE,SAAA;EACA,kBAAA;EACA,2BAAA;ADtFN;ACyFI;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;ADvFN;ACyFM;EACE,qCAAA;ADvFR;AC2FI;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;ADzFN;;AC6FA;EACE,cCjuCO;EDkuCP,cAAA;AD1FF;;AC6FA;EACE,mBAAA;AD1FF;AC2FE;EACE,cAAA;EACA,eAAA;EACA,cC1vCQ;AFiqCZ;AC2FE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,yBAAA;ADzFJ;AC0FI;EACE,gBAAA;EACA,eAAA;EACA,qBCjxCK;EDkxCL,0CAAA;ADxFN;AC0FI;EACE,qBCrxCK;AF6rCX;;AC6FA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AD1FF;;AC6FA;EACE,gDAAA;AD1FF;;AC6FA;EACE;IAAK,eAAA;EDzFL;EC0FA;IAAO,kBAAA;EDvFP;AACF;AArtCA;EACE,aAAA;EACA,sBAAA;AAutCF;;AAptCA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAutCF;AArtCE;EACE,WAAA;EACA,YAAA;AAutCJ;;AAltCA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAqtCF;;AAltCA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,OAAA;AAqtCF;AAntCE;EACE,YAAA;AAqtCJ;;AAhtCA;EACE,gBAAA;EACA,oBAAA;EAGA,aAAA;EACA,cAAA;EAIA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EAGA,8BAAA;EACA,qBAAA;EACA,YAAA;EACA,0CAAA;AAmtCF;;AAhtCA;EACE,WAAA;EACA,YAAA;AAmtCF;AAjtCE;EACE,aAAA;AAmtCJ;;AA/sCA;EACE,uBAAA;AAktCF;;AA/sCA;EACE,gBAAA;AAktCF;;AA/sCA;EACE,cAAA;AAktCF;;AA/sCA;EACE,aAAA;AAktCF;;AA/sCA;EACE;IACE,wBAAA;EAktCF;EA/sCA;IACE,yBAAA;EAitCF;EA9sCA;IACE,iBAAA;IACA,kBAAA;EAgtCF;EA7sCA;IACE,WAAA;EA+sCF;EA5sCA;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EA8sCF;AACF;AA3sCA;EACE;IACE,iBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+DAAA;IACA,qBAAA;EA6sCF;EA1sCA;IACE,eAAA;IACA,eAAA;IACA,kBAAA;IACA,wBAAA;IACA,mBAAA;IACA,gEAAA;EA4sCF;AACF;AAzsCA;EACE;IACE,qBAAA;IACA,iBAAA;IACA,eAAA;EA2sCF;EAzsCA;IACE,qBAAA;IACA,iBAAA;IACA,eAAA;IACA,aAAA;EA2sCF;AACF;AAxsCA;EACE;IAAW,iBAAA;EA2sCX;EA1sCA;IAAO,oBAAA;EA6sCP;AACF;AA1sCA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA4sCF;;AAzsCA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AA4sCF;;AAzsCA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA4sCF;AA1sCE;EACE,eAAA;EACA,YAAA;EACA,aAAA;AA4sCJ","sourcesContent":["@import '../../../../../sass/variables';\n@import './../../components/checkout/checkout.component';\n\n.panel-body1 {\n  display: flex;\n  flex-direction: column;\n}\n\n.body-qrcode {\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n\n  .button-expand {\n    width: 50px;\n    height: 50px;\n  }\n\n}\n\n.align-center {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo__pix {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  flex: 1;\n\n  svg {\n    width: 170px;\n  }\n\n}\n\n.compartilhar {\n  margin-top: 30px;\n  margin-bottom: unset;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: #8b8b8b;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  text-align: start;\n  height: 40px;\n  border-radius: 5px;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  align-content: center;\n  width: 428px;\n  border: 2px solid rgba(216, 216, 216, 0.5);\n}\n\n.link-field {\n  width: 100%;\n  border: none;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.copiar-pix {\n  width: 120px !important;\n}\n\n.short-link {\n  margin-top: 10px;\n}\n\n.qrcode__desktop {\n  display: block;\n}\n\n.qrcode__mobile {\n  display: none;\n}\n\n@media only screen and ( max-width: 450px) {\n  .qrcode__desktop {\n    display: none !important;\n  }\n\n  .qrcode__mobile {\n    display: block !important;\n  }\n\n  .compartilhar {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  .panel-body1 {\n    width: 100%;\n  }\n\n  .pix__copiar {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n@supports (animation: grow .5s cubic-bezier(.25, .25, .25, 1) forwards) {\n  .tick {\n    stroke-opacity: 0;\n    stroke-dasharray: 29px;\n    stroke-dashoffset: 29px;\n    animation: draw .5s cubic-bezier(.25, .25, .25, 1) forwards;\n    animation-delay: .6s\n  }\n\n  .circle {\n    fill-opacity: 0;\n    stroke: #2cd355;\n    stroke-width: 16px;\n    transform-origin: center;\n    transform: scale(0);\n    animation: grow 1s cubic-bezier(.25, .25, .25, 1.25) forwards;\n  }\n}\n\n@keyframes grow {\n  60% {\n    transform: scale(.8);\n    stroke-width: 4px;\n    fill-opacity: 0;\n  }\n  100% {\n    transform: scale(.9);\n    stroke-width: 8px;\n    fill-opacity: 1;\n    fill: #2cd355;\n  }\n}\n\n@keyframes draw {\n  0%, 100% { stroke-opacity: 1; }\n  100% { stroke-dashoffset: 0; }\n}\n\n\nbody {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.cobranca__processada {\n  width: 420px;\n  height: 480px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 20px;\n  color: #2cd355;\n}\n\n.loading {\n  width: 420px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    stroke: #548bfe;\n    width: 100px;\n    height: 100px;\n  }\n}\n","@import '../../../../../sass/variables';\n\n.checkout {\n  background-color: $white;\n}\n.compartilhar {\n  margin-top: -40px;\n  margin-bottom: 60px;\n  display: flex;\n  color: #8b8b8b;\n  flex-direction: row;\n  text-align: start;\n  height: 40px;\n  border-radius: 5px;\n  justify-content: space-between;\n  align-content: center;\n  width: 100%;\n  border: 2px solid rgba(216, 216, 216, 0.5);\n\n  .link-field {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    height: 100%;\n    padding-left: 5px;\n    span {\n      align-self: center;\n    }\n  }\n\n  .button-link-field {\n    height: 100%;\n    width: 80px;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    background-color: #ededed;\n    cursor: pointer;\n    transition: .3s ease;\n\n    &:hover {\n      background-color: #E8E8E8FF;\n    }\n    span {\n      align-self: center;\n    }\n\n  }\n}\n\n.panel {\n  background-color: $white;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n}\n\n.form-control {\n  border: 1px solid $cinza-300;\n}\n\n#form-checkout .has-error input {\n  border-color: $danger;\n  &:focus, &:hover {\n    border: 1px solid $danger;\n  }\n}\n\n.form-control.error {\n    border: 1px solid $danger;\n    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;\n    transform: translate3d(0, 0, 0);\n    backface-visibility: hidden;\n    perspective: 1000px;\n  }\n\n  @keyframes shake {\n    10%,\n    90% {\n      transform: translate3d(-1px, 0, 0);\n    }\n    20%,\n    80% {\n      transform: translate3d(2px, 0, 0);\n    }\n    30%,\n    50%,\n    70% {\n      transform: translate3d(-4px, 0, 0);\n    }\n    40%,\n    60% {\n      transform: translate3d(4px, 0, 0);\n    }\n  }\n\n  /*  alterações novas  */\n\n  .panel-body-altera {\n    text-align: right;\n  }\n\n  .panel-body-altera .btn-confirmar {\n    margin-bottom: 5px;\n  }\n\n  .panel-body-altera .cartoes-cadastrados {\n      padding-bottom: 80px;\n      padding-top: 10px;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao {\n    padding: 10px;\n    border: 2px solid #00caff;\n    border-radius: 5px;\n    background-color: #fff;\n    text-align: left;\n    height: 46px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n    color: hsl(0, 0%, 30%);\n    font-size: 13px;\n    cursor: pointer;\n    user-select: none;\n    transition: all 0.5s ease-out;\n    position: relative;\n    &.card-red {\n      border: 2px solid $danger;;\n    }\n    .error-action-card {\n      color: $danger;\n      position: absolute;\n      bottom: -10px;\n      left: 10px;\n    }\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.disabled {\n    background-color: #fcfcfc;\n    border: 2px solid rgba(216, 216, 216, 0.5);\n    color: #8b8b8b;\n    transition: background-color 0.5s ease, border-color 0.5s ease;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.disabled:hover {\n    background-color: #fff;\n    border-color: rgba(216, 216, 216, 1);\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.novo-cartao {\n    background-color: #fcfcfc;\n    border: 2px solid rgba(216, 216, 216, 0.5);\n    ;\n    color: #4379ff;\n    font-family: $fonte-pague-la;\n    font-size: 15px;\n    font-weight: bolder;\n    padding-left: 30px;\n    transition: background-color 0.5s ease, border-color 0.5s ease;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.novo-cartao:hover {\n    background-color: #fff;\n    border-color: rgba(216, 216, 216, 1);\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao.novo-cartao span>span {\n    font-size: 19px;\n    line-height: 1;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao .bandeira-cartao {\n    margin: 0;\n    display: inline-block;\n    vertical-align: middle;\n    height: 26px;\n    width: 66px;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao .editar-cartao-button {\n    width: 7px;\n    height: 19px;\n    display: inline-block;\n    background-image: url(/assets/icones/menu-edit.svg);\n    background-repeat: no-repeat;\n    padding: 10px;\n    background-position: center;\n  }\n\n  .panel-body-altera .cartoes-cadastrados .cartao .final-pan strong,\n  .cartoes-cadastrados .cartao .validade-cartao strong {\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-size: 15px;\n  }\n\n  .remover-dom {\n    visibility: hidden;\n    opacity: 0;\n    display: none;\n  }\n\n  .flex {\n    display: flex;\n  }\n\n  .space-between {\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  h5 {\n    color: #4d4d4d;\n    font-size: 14px;\n    line-height: inherit;\n  }\n\n  .info-venda .venda:last-child {\n      margin-bottom: 20px;\n  }\n\n  .venda .valores {\n      margin-bottom: 5px;\n  }\n\n  .venda .data-entrada {\n      font-size: 12px;\n      text-align: right;\n      position: relative;\n  }\n\n  .venda .data-entrada .texto-data {\n    position: absolute;\n    left: 0px;\n    color: #999999;\n  }\n\n  .venda .data-entrada .valor-data {\n      font-family: pague-la, \"Open Sans\", sans-serif;\n      font-weight: bolder;\n      font-size: 13px;\n  }\n\n  .venda .valor-entrada{\n    display: block;\n    font-family: pague-la, \"Open Sans\", sans-serif;\n    font-weight: bolder;\n    font-size: 13px;\n    text-align: right;\n  }\n\n  /* #cartoes-cadastrados, #form-checkout {\n      transition: opacity 0.5s ease;\n  } */\n\n  @media (min-width: 768px) {\n    .checkout .cls-content .cls-content-lg {\n      width: 700px;\n    }\n  }\n\n  .menu-remove {\n    background-color: #FFF;\n    width: 100px;\n    height: 35px;\n    border: 1px solid rgba(0,0,0,.15);\n    padding: 7px;\n    text-align: center;\n    border-radius: .25rem;\n    position: relative;\n    top: 12px;\n    left: -78px;\n    z-index: 10;\n  }\n\n  .menu-remove:hover {\n    background-color: #EFEFEF;\n  }\n\n  @media (min-width: 768px) {\n    .checkout .cls-content .cls-content-lg {\n      width: 700px;\n    }\n  }\n\n  // @font-face {\n  //   font-family: 'pague-la';\n  //   src: url('/assets/fonts/pague-la.eot');\n  //   src: url('/assets/fonts/pague-la.eot?#iefix') format('embedded-opentype'), url('/assets/fonts/pague-la.woff2') format('woff2'), url('/assets/fonts/pague-la.woff') format('woff'), url('/assets/fonts/pague-la.ttf') format('truetype');\n  //   font-weight: 300;\n  //   font-style: normal;\n  // }\n\n  .checkout.cls-container {\n    background-color: #FFFFFF;\n  }\n\n  .checkout .cls-content {\n    padding-top: 5vh;\n  }\n\n  .checkout .rodape {\n    margin-top: 30px;\n  }\n\n  .checkout .rodape p {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .checkout .panel-content {\n    display: flex;\n  }\n\n  .checkout p,\n  .checkout h4,\n  .checkout h5 {\n    display: table;\n  }\n\n  .mb-clean {\n    margin-bottom: 0;\n  }\n\n  .checkout .panel-body1 {\n    width: 35%;\n    background-color: #fff;\n    padding: 20px 40px 25px;\n    border-bottom-left-radius: 10px;\n  }\n\n  .checkout .panel-body1 .total {\n    font-size: 18px;\n    font-family: $fonte-pague-la;\n  }\n\n  .checkout .panel-body1 p {\n    color: #999999;\n    margin-bottom: 8px;\n  }\n\n  .checkout .panel-body1 h4 {\n    color: #4379ff;\n    font-family: $fonte-pague-la;\n    font-size: 25px;\n    font-weight: 900;\n    margin-top: 0;\n  }\n\n  .checkout .texto-destaque {\n    color: #4379ff;\n    font-family: $fonte-pague-la;\n    font-size: 18px;\n    font-weight: 900;\n    margin-top: 0;\n  }\n\n.checkout .texto-destaque-normal {\n  color: #4379ff;\n  font-family: $fonte-pague-la;\n  font-size: 18px;\n  font-weight: 400;\n  margin-top: 0;\n}\n\n  .checkout .panel-body1 h5 {\n    margin-top: 15px;\n  }\n\n  .checkout .panel-body2 {\n    width: 65%;\n    background-color: #fcfcfc;\n    padding: 20px 40px 35px;\n  }\n\n  .checkout .panel .desc-parcelas {\n    text-align: right;\n  }\n\n.checkout .panel .desc-parcelas p {\n    color: #999999;\n    display: inline-block;\n  }\n\n  @media (min-width: 768px) {\n    .checkout .cartao-credito {\n      width: 100%;\n    }\n\n    #resultado-reprovado {\n      .link-back {\n        position: absolute;\n        bottom: 40px;\n        left: none;\n      }\n    }\n  }\n\n  .checkout .form-control {\n    font-size: 15px;\n    font-weight: bolder;\n  }\n\n  input:-moz-placeholder,\n  input::-webkit-input-placeholder,\n  input:-ms-input-placeholder {\n    color: red;\n  }\n\n  .checkout .panel {\n    border-radius: 10px;\n  }\n\n  .checkout .panel-heading {\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    height: 80px;\n    border-bottom: none;\n  }\n\n  .panel-title a {\n    color: inherit;\n    cursor: pointer;\n  }\n\n  .pagamento-seguro {\n    text-align: right;\n    position: absolute;\n    right: 40px;\n    top: 20px;\n    color: #ffffff;\n  }\n\n  .pagamento-seguro p {\n    display: inline-block;\n  }\n\n  .pagamento-seguro p strong {\n    display: block;\n  }\n\n  .checkout .panel-heading:after {\n    border-bottom: none;\n  }\n\n  .checkout .logo-paguela-cinza {\n    margin-bottom: 30px;\n  }\n\n  .checkout .logo-paguela-cinza svg {\n    height: 30px;\n  }\n\n  .checkout .panel-heading h3 {\n    color: #fff;\n    letter-spacing: 1px;\n    text-align: left;\n    font-size: 25px;\n    padding-top: 15px;\n    padding-left: 40px;\n    font-family: $fonte-pague-la;\n    font-weight: 100;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    cursor: default;\n  }\n\n  z .checkout label,\n  .registro .pad-all {\n    color: #999999;\n  }\n\n  .checkout input,\n  .registro select {\n    border-radius: 4px;\n    border-color: #d9d9d9;\n  }\n\n  .checkout input:focus {\n    border-color: #00CAFF;\n  }\n\n  .checkout .panel-heading {\n    background: rgba(0, 204, 255, 1);\n    background: -moz-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 204, 255, 1)), color-stop(70%, rgba(161, 80, 253, 1)), color-stop(100%, rgba(177, 54, 253, 1)));\n    background: -webkit-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -o-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: -ms-linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    background: linear-gradient(15deg, rgba(0, 204, 255, 1) 0%, rgba(161, 80, 253, 1) 70%, rgba(177, 54, 253, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ccff', endColorstr='#b136fd', GradientType=1);\n  }\n\n  .mt-20 {\n    margin-top: 20px;\n  }\n\n  .btn-registrar,\n  .btn-primary {\n      position: absolute;\n      bottom: 40px;\n      right: 40px;\n      font-family: $fonte-pague-la;\n      color: $white;\n      font-size: 1.8rem;\n      padding: 7.5px 27px;\n      border-radius: 5px;\n      letter-spacing: 0.8px;\n      background: #22b5ff;\n      background: -moz-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));\n      background: -webkit-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -o-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -ms-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#22b5ff', endColorstr='#a42cff', GradientType=1);\n      border: none;\n      float: right;\n\n    @media screen and (max-width: 769px) {\n      bottom: 10px;\n      right: 20px;\n    }\n  }\n\n  .btn-registrar:active,\n  .btn-primary:active,\n  .btn-registrar:hover,\n  .btn-primary:hover,\n  .btn-registrar:focus .btn-primary:focus {\n      color: #fff;\n      background: #22b5ff;\n      background: -moz-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -webkit-gradient(left bottom, right top, color-stop(0%, #22b5ff), color-stop(25%, #4378ff), color-stop(50%, #6a5cff), color-stop(75%, #8e42ff), color-stop(100%, #a42cff));\n      background: -webkit-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -o-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: -ms-linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      background: linear-gradient(45deg, #22b5ff 0%, #4378ff 25%, #6a5cff 50%, #8e42ff 75%, #a42cff 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#22b5ff', endColorstr='#a42cff', GradientType=1);\n  }\n\n  #reinicia-venda {\n    float: none;\n  }\n\n  .cadeado {\n    max-width: 35px;\n    display: inline-block;\n    position: relative;\n    top: 2px;\n  }\n\n  .cadeado svg {\n    height: 30px;\n  }\n\n  #cartao-error {\n    margin-bottom: 0 !important;\n  }\n\n  .checkout .form-group {\n    margin-bottom: 15px;\n  }\n\n  .checkout .form-group .control-label {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n  }\n\n  img.logo-cliente {\n    max-width: 165px;\n    max-height: 117px;\n    margin: 10px auto;\n  }\n\n  .bandeira-cartao {\n    width: 50px;\n    height: 27px;\n    background-size: 100% auto;\n    background-repeat: no-repeat;\n    margin: 7px 0 0 0;\n    opacity: 0;\n    -webkit-transition: opacity .5s ease;\n    transition: opacity .5s ease;\n    right: 8px;\n    top: 3px;\n  }\n\n  .checkout .has-feedback label~.form-control-feedback {\n    top: 27px;\n    right: 10px;\n  }\n\n  .default {\n    opacity: 0;\n  }\n\n  .master,\n  .visa,\n  .elo,\n  .diners,\n  .aura,\n  .jcb,\n  .hipercard,\n  .amex {\n    opacity: 1;\n  }\n\n  .master {\n    background-image: url('/assets/icones/mastercard.svg');\n  }\n\n  .hipercard {\n    background-image: url('/assets/icones/hipercard.png');\n  }\n\n  .visa {\n    background-image: url('/assets/icones/visa.svg');\n  }\n\n  .amex {\n    background-image: url('/assets/icones/american-express.svg');\n  }\n\n  .diners {\n    background-image: url('/assets/icones/diners.svg');\n  }\n\n  .discover {\n    background-image: url('/assets/icones/discover.svg');\n  }\n\n  .elo {\n    background-image: url('/assets/icones/elo.svg');\n  }\n\n  .jcb {\n    background-image: url('/assets/icones/jbc.png');\n  }\n\n  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n  only screen and (min-resolution: 1.5dppx),\n  (-webkit-min-device-pixel-ratio: 1.5),\n  (min-resolution: 144dpi) {\n    .jcb {\n      background-image: url('/assets/icones/jbc@2x.png');\n    }\n  }\n\n  .aura {\n    background-image: url('/assets/icones/aura.png');\n  }\n\n  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n  only screen and (min-resolution: 1.5dppx),\n  (-webkit-min-device-pixel-ratio: 1.5),\n  (min-resolution: 144dpi) {\n    .aura {\n      background-image: url('/assets/icones/aura@2x.png');\n    }\n  }\n\n  .btn.loading {\n    color: transparent;\n    height: 35px;\n    width: 35px;\n    padding: 0;\n    border-radius: 50%;\n    animation: loadBotao .25s ease, spin .75s linear infinite .25s;\n  }\n\n  .btn.loading:before {\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    border-radius: 50%;\n    background-color: #fcfcfc;\n    position: relative;\n    display: block;\n    margin: 1px;\n  }\n\n  @keyframes loadBotao {\n    from {\n      height: initial;\n      width: initial;\n    }\n    to {\n      height: 35px;\n      width: 35px;\n    }\n  }\n\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  #nometitular-error {\n    margin-bottom: 40px;\n  }\n\n  #nometitular-error,\n  #cartao-error {\n    color: #eb2521;\n  }\n\n  @media (max-width: 767px) {\n    .checkout .panel-heading h3 {\n      padding-left: 20px;\n    }\n\n    .checkout .cls-content {\n      padding: 0;\n    }\n\n    .checkout .cls-content .cls-content-lg{\n      width: 100%;\n      box-shadow: none;\n    }\n\n    .checkout .panel-content {\n      display: block;\n    }\n    .logo-cliente {\n      display: block !important;\n    }\n    .info-loja * {\n      display: block !important;\n    }\n    .panel-body2,\n    .panel-body1 {\n      width: 100% !important;\n      text-align: center;\n      padding: 20px !important;\n    }\n    .pagamento-seguro {\n      right: 20px;\n    }\n    .info-pagamento {\n      display: flex;\n      justify-content: space-between;\n    }\n    #nometitular {\n      margin-bottom: 100px;\n    }\n    .checkout .panel-heading {\n      border-radius: 0;\n    }\n    /* .checkout .panel-heading h3 {\n      position: relative;\n      text-align: center;\n      padding: 15px 0 0;\n    }\n    .pagamento-seguro {\n      position: relative;\n      text-align: center;\n      top: 0;\n      right: 0;\n    }\n    .pagamento-seguro p {\n      text-align: right;\n    } */\n    .checkout .panel-body1 p.totais {\n      position: absolute;\n      float: left;\n      left: 50%;\n      transform: translate(-50%, 0);\n    }\n  }\n\n  #resultado-sucesso h3 {\n    display: block;\n    color: #00caff;\n    font-family: $fonte-pague-la;\n    margin-top: 8px;\n  }\n\n  #resultado-reprovado h3 {\n    display: block;\n    color: #e95753;\n    margin-top: 8px;\n    font-family: $fonte-pague-la;\n  }\n\n  /*altura SVGS de validação*/\n\n  #resultado-sucesso svg,\n  #resultado-reprovado svg {\n    height: 75px;\n  }\n\n  /*animação círculos svgs*/\n\n  #resultado-sucesso svg circle,\n  #resultado-reprovado svg circle {\n    stroke-dasharray: 1000;\n    stroke-dashoffset: 1000;\n    animation: dash 2.5s ease forwards;\n  }\n\n  @keyframes dash {\n    to {\n      stroke-dashoffset: 0;\n    }\n  }\n\n  /* animação somente de sucesso */\n\n  #resultado-sucesso svg polyline {\n    stroke-dasharray: 1000;\n    stroke-dashoffset: 1000;\n    animation: dash 3.5s ease forwards;\n    animation-delay: 0.25s;\n  }\n\n  #resultado-reprovado svg .linha-1 {\n    transform: translate(20px, -20px);\n    opacity: 0;\n    animation: entrando 0.25s ease-in forwards;\n    animation-delay: 0.3s;\n  }\n\n  #resultado-reprovado svg .linha-2 {\n    transform: translate(-20px, -20px);\n    opacity: 0;\n    animation: entrando 0.25s ease-in forwards;\n    animation-delay: 0.4s;\n  }\n\n  @keyframes entrando {\n    to {\n      transform: translate(0px, 0px);\n      opacity: 1;\n    }\n  }\n\n  /* animação reprovado */\n\n  #resultado-reprovado svg {\n    animation: shake-reprovado 0.35s ease forwards;\n    animation-delay: 0.6s;\n  }\n\n  @keyframes shake-reprovado {\n    10%,\n    90% {\n      transform: translate3d( 0, -1px, 0);\n    }\n    20%,\n    80% {\n      transform: translate3d( 0, 2px, 0);\n    }\n    30%,\n    50%,\n    70% {\n      transform: translate3d( 0, -4px, 0);\n    }\n    40%,\n    60% {\n      transform: translate3d(0, 4px, 0);\n    }\n  }\n\n  #resultado-sucesso .bandeira-cartao {\n    position: absolute;\n    top: -5px;\n    right: 0px;\n  }\n\n  #resultado-sucesso .info-cartao {\n    position: relative;\n    padding-right: 75px;\n  }\n\n  #resultado-sucesso .fechar {\n    margin-top: 40px;\n  }\n\n  #resultado-sucesso .info-transacao-aprovada {\n    margin-top: 20px;\n  }\n\n  #resultado-sucesso .info-transacao-aprovada hr {\n    margin: 10px 0 !important;\n  }\n\n  #resultado-sucesso .dados-aprovados {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .margin-auto {\n    margin: 0 auto;\n  }\n\n  .mb-30 {\n    margin-bottom: 30px !important;\n  }\n\n  .mt-30 {\n    margin-top: 30px !important;\n  }\n\n  /* página 404 */\n\n  .pagina-404 #container {\n    background: rgba(0, 247, 255, 1);\n    background: -moz-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 247, 255, 1)), color-stop(75%, rgba(170, 0, 255, 1)), color-stop(100%, rgba(170, 0, 255, 1)));\n    background: -webkit-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: -o-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: -ms-linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    background: linear-gradient(45deg, rgba(0, 247, 255, 1) 0%, rgba(170, 0, 255, 1) 75%, rgba(170, 0, 255, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00f7ff', endColorstr='#aa00ff', GradientType=1);\n  }\n\n  .pagina-404 .btn-confirmar {\n    position: initial;\n  }\n\n  .pagina-404 .text-main {\n    font-family: pague-la, 'open sans', sans-serif;\n    font-size: 2rem;\n  }\n\n  h1.error-code {\n    font-family: pague-la, 'open sans', sans-serif;\n    color: #fff;\n  }\n\n  .checkout-table {\n    width: 100%;\n    margin: 20px 0;\n    tbody {\n      tr {\n        td {\n          color: $cinza-600;\n          border-bottom: 1px solid $cinza-400;\n          padding: 10px 0 5px;\n        }\n      }\n    }\n  }\n\n  .scheduled-transations {\n    margin-top: 40px;\n  }\n\n  .show-table {\n    overflow: hidden;\n    max-height: 300px;\n    transition: max-height 1s ease;\n  }\n\n  .hide-table {\n    overflow: hidden;\n    max-height: 0px;\n    transition: max-height 1s ease;\n  }\n\n  .modal-checkout {\n    z-index: 10;\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    display: none;\n    top: 0;\n    left: 0;\n    background-color: rgba(#120040, 0.85);\n    font-family: $fonte-pague-la;\n    &.modal-checkout-show {\n      display: block;\n      animation-name: fade;\n      animation-duration: 0.4s;\n      animation-fill-mode: forwards;\n      animation-timing-function: ease-in-out;\n      .icon {\n        animation-name: fade;\n        animation-delay: 0.2s;\n        animation-duration: 0.2s;\n        animation-fill-mode: forwards;\n        animation-timing-function: ease-in-out;\n      }\n      span:first-child {\n        animation-name: fade;\n        animation-delay: 0.4s;\n        animation-duration: 0.5s;\n        animation-fill-mode: forwards;\n        animation-timing-function: ease-in-out;\n      }\n      span:last-child {\n        animation-name: fade;\n        animation-delay: 0.6s;\n        animation-duration: 0.8s;\n        animation-fill-mode: forwards;\n        animation-timing-function: ease-in-out;\n      }\n      button {\n        animation-name: fade;\n        animation-delay: 0.8s;\n        animation-duration: 1.1s;\n        animation-fill-mode: forwards;\n        animation-timing-function: ease-in-out;\n      }\n    }\n\n    div:first-child {\n      position: relative;\n      top: 30%;\n    }\n\n    span {\n      opacity: 1;\n      width: 100%;\n      display: inline-block;\n    }\n\n    .icon {\n      opacity: 1;\n      width: 60px;\n      margin: 0 auto;\n\n      img {\n        width: 100%;\n        margin: 20px 0;\n      }\n    }\n\n    .text {\n      color: $white;\n      font-size: 36px;\n    }\n\n    .button {\n      top: 120px;\n      left: 40px;\n      right: 0;\n      width: 200px;\n      margin: 0 auto;\n      transition: 0.5s;\n      position: relative;\n\n      button {\n        opacity: 0;\n        width: 200px;\n      }\n    }\n  }\n\n  .erro-reprovacao {\n    margin-bottom: 80px;\n  }\n\n  .link-back {\n    margin-top: 50px;\n    a {\n      transition: 0s;\n      h4 {\n        display: block;\n        font-size: 18px;\n        font-weight: 500;\n        color: #00caff;\n        font-family: $fonte-pague-la;\n      }\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  #resultado-reprovado, #cartoes-cadastrados, #form-checkout {\n    .link-back {\n      position: absolute;\n      bottom: 40px;\n      left: 40px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    #resultado-reprovado, #cartoes-cadastrados, #form-checkout {\n      .link-back {\n        bottom: 40px;\n        left: inherit;\n        position: absolute;\n      }\n    }\n  }\n\n  .valication-result-error {\n    text-align: center;\n    color: $danger;\n  }\n\n  a {\n    cursor: pointer;\n  }\n\n\n  .qtd-vezes {\n    font-size: 10px;\n    color: #4379ff;\n  }\n\n  .button-not-allowed {\n    top: 120px;\n    left: 40px;\n    right: 0;\n    width: 200px;\n    margin: 0 auto;\n    transition: 0.5s;\n    position: relative;\n\n    button {\n      opacity: 1;\n      width: 200px;\n    }\n  }\n\n  .iframe-cybersource {\n    border: 0;\n    width: 100%;\n    height: 100%;\n    top: -5000px;\n    position: absolute;\n  }\n\n  .mb-70 {\n    margin-bottom: 70px;\n  }\n\n  .modal-header {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 90px;\n    padding: 15px;\n    position: absolute;\n    &:after {\n        content: normal;\n    }\n    h2 {\n        font-weight: 100;\n        text-align: center;\n    }\n    &.header-removido {\n        background-color: rgba($azul-400, .25);\n        h2 {\n            color: $azul-400;\n        }\n    }\n    &.header-remover {\n        background-color: rgba($danger, 0.25);\n        h2 {\n          color: $danger;\n      }\n    }\n  }\n\n  .modal-body {\n    margin-top: 90px;\n\n    .text-center {\n      text-align: center;\n    }\n\n    p {\n      font-size: 14px;\n      font-weight: 600;\n\n      &.info-cartao {\n        margin: 5px 0 0 -4px;\n      }\n\n      .bandeira-cartao {\n        margin-top: -4px;\n        margin-right: 5px;\n      }\n\n      small {\n        margin-left: 5px;\n        color: $cinza-500;\n        font-weight: 200;\n      }\n    }\n\n    h3 {\n      margin-bottom: 30px;\n      margin-top: 0px;\n      font-size: 18px;\n    }\n\n    .empty {\n      color: $cinza-500;\n      font-weight: 300;\n      font-size: 16px;\n    }\n\n    .color-red {\n      color: $danger;\n    }\n\n    .btn-action {\n      float: left;\n      position: relative;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n    .btn {\n      margin-top: 20px;\n\n      &:first-child {\n        margin-right: 2px;\n      }\n\n      &:last-child {\n        margin-left: 2px;\n      }\n\n      &.loading {\n        margin-right: 30px;\n\n        &::before {\n          background-color: #fff;\n        }\n      }\n    }\n\n    .btn-remover {\n      float: right;\n      color: #fff;\n      line-height: 23px;\n      background-color: rgba($danger, 1);\n    }\n\n    .btn-default {\n      font-size: 16px;\n      padding: 5.5px 16px;\n      border: none;\n      background-color: rgba($cinza-400, 0.25);\n\n      &:hover {\n        background-color: rgba($cinza-400, 0.5);\n      }\n    }\n\n    .btn-excluido {\n      left: 50%;\n      position: relative;\n      transform: translateX(-50%);\n    }\n\n    .textarea {\n      border: 0px;\n      outline: none;\n      margin-top: 15px;\n      margin-bottom: 10px;\n      padding: 0px 12px;\n\n      &.color-red {\n        box-shadow: 0px 0px 12px -2px rgba($danger, 1);\n      }\n    }\n\n    svg {\n      left: 50%;\n      width: 90px;\n      height: 90px;\n      position: relative;\n      margin-bottom: 50px;\n      transform: translateX(-50%);\n    }\n  }\n\n.cartao-invalido, .bandeira-invalida {\n  color: $danger;\n  display: block;\n}\n\n.bandeiras {\n  margin-bottom: 10px;\n  label {\n    display: block;\n    font-size: 12px;\n    color: $cinza-500;\n  }\n  figure {\n    padding: 2px;\n    transition: .6s;\n    border-radius: 3px;\n    margin: 0 4px 15px 0;\n    background-size: 40px auto;\n    border: solid 1px $cinza-200;\n    &:hover {\n      transition: .6s;\n      cursor: pointer;\n      border-color: $azul-300;\n      background-color: rgba($cinza-100, .4);\n    }\n    &.bandeira-selecionada {\n      border-color: $azul-300;\n    }\n  }\n}\n\n.footer-credito-parcelado {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.checkout-bloqueado {\n  animation: blur-bloqueio 1s ease-in-out forwards;\n}\n\n@keyframes blur-bloqueio {\n  0% { filter: blur(0); }\n  100% { filter: blur(20px); }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
